import { BASE_LIGHT_THEME as a } from "./index.es5422.js";
import { COLOR_PRIMITIVES as e } from "./index.es648.js";
const s = {
  ...a,
  POI: {
    1: {
      default: e.brand.base[80].default,
      light: e.brand.base[60],
      disabled: e.brand.base[50],
      dark: e.brand.base[90],
      overlap: e.brand.base[80].opac40
    },
    2: {
      default: e.pink.base[30].default,
      light: e.pink.base[20],
      disabled: e.pink.base[10],
      dark: e.red.base[30],
      overlap: e.pink.base[30].opac20
    },
    3: {
      default: e.green.base[35].default,
      light: e.green.base[25],
      disabled: e.green.base[10],
      dark: e.green.base[40],
      overlap: e.green.base[35].opac40
    },
    4: {
      default: e.purple.base[30].default,
      light: e.purple.base[20],
      disabled: e.purple.base[10],
      dark: e.purple.base[40],
      overlap: e.purple.base[30].opac40
    },
    5: {
      default: e.olive.base[30].default,
      light: e.olive.base[20],
      disabled: e.olive.base[10],
      dark: e.olive.base[40],
      overlap: e.olive.base[30].opac40
    },
    6: {
      default: e.brown.base[70].default,
      light: e.brown.base[60],
      disabled: e.brown.base[20],
      dark: e.brown.base[80],
      overlap: e.brown.base[70].opac40
    },
    7: {
      default: e.blue.base[35].default,
      light: e.blue.base[25],
      disabled: e.blue.base[10],
      dark: e.blue.base[40],
      overlap: e.blue.base[35].opac40
    },
    8: {
      default: e.brown.base[55],
      light: e.brown.base[35],
      disabled: e.brown.base[25],
      dark: e.brown.base[50],
      overlap: e.brown.base[40].opac40
    }
  }
};
export {
  s as LIGHT_A11Y_THEME
};
//# sourceMappingURL=index.es652.js.map
